interface ImageSize {
    width: number;
    height: number;
}

class ImageUrl {
    public static isRelationshipUrl = (url: string): boolean => !!url?.startsWith('rel:');
    public static isBlobUrl = (url: string): boolean => !!url?.startsWith('blob:');
    public static isCDNUrl = (url: string): boolean => !!url?.match(/^(https?:)\/\/?/i);
    public static isBase64Url = (url: string): boolean => !!url?.match(/^data:image\/(.*);base64/i);

    public static stripAllTags = (url: string): string => {
        if (ImageUrl.isBlobUrl(url)) {
            return url.replace(/[#?].*$/, '');
        }

        return url;
    };

    public static attachImageSizeToUrl(url: string, imageSize: ImageSize): string {
        return `${url}#w=${imageSize.width}#h=${imageSize.height}`;
    }

    public static getImageSizeFromUrl(url?: string): ImageSize {
        if (!url) return { width: 0, height: 0 };

        if (ImageUrl.isBlobUrl(url)) {
            const width = parseInt(/#w=(\d+)/.exec(url)?.[1] ?? '', 10);
            const height = parseInt(/#h=(\d+)/.exec(url)?.[1] ?? '', 10);

            return { width, height };
        }

        const searchParams = new URLSearchParams(url.split('?')[1] ?? '');
        const width = parseInt(searchParams.get('w') ?? '', 10);
        const height = parseInt(searchParams.get('h') ?? '', 10);

        return { width, height };
    }

    private static getAllTags = (url: string) => new Set(url.split('#').slice(1));
}

export default ImageUrl;
